module.exports = __webpack_public_path__ + "static/loading-7090d284a2e355da1bd2890713c2243f.gif";